import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import axios from "axios";
import { ArrowLeft, Loader2 } from "lucide-react";
import { Overline } from "@/components/Reveal";
import { API } from "@/data/campaign";
import { isVideoUrl } from "@/utils/media";

const CampaignPost = () => {
  const { slug } = useParams();
  const [post, setPost] = useState(null);
  const [missing, setMissing] = useState(false);

  useEffect(() => {
    axios
      .get(`${API}/news/campaign/${slug}`)
      .then(({ data }) => {
        setPost(data);
        document.title = `${data.title} — Amin Nanji for Ward 11`;
        if (data.excerpt) {
          let el = document.head.querySelector('meta[name="description"]');
          if (el) el.setAttribute("content", data.excerpt);
        }
      })
      .catch(() => setMissing(true));
  }, [slug]);

  return (
    <main data-testid="campaign-post-page" className="pt-28 lg:pt-32">
      <section className="mx-auto max-w-3xl px-5 pb-24 sm:px-8">
        <Link
          to="/news"
          data-testid="post-back-link"
          className="group inline-flex items-center gap-2 font-mono text-xs uppercase tracking-[0.2em] text-ink/60 transition-colors hover:text-terra-500"
        >
          <ArrowLeft className="h-3.5 w-3.5 transition-transform group-hover:-translate-x-1" />
          Back to News
        </Link>

        {!post && !missing && (
          <div className="flex items-center gap-2 py-20 text-ink/50">
            <Loader2 className="h-5 w-5 animate-spin" /> Loading…
          </div>
        )}
        {missing && <p className="py-20 font-serif text-2xl text-ink/60">This campaign update could not be found.</p>}
        {post && (
          <article className="mt-10">
            <Overline>Campaign Update</Overline>
            <h1 className="mt-4 font-serif text-4xl font-medium leading-[1.1] tracking-tight sm:text-5xl">{post.title}</h1>
            <p className="mt-4 font-mono text-xs uppercase tracking-[0.2em] text-ink/50">
              {new Date(post.published_at || post.created_at).toLocaleDateString("en-CA", {
                year: "numeric", month: "long", day: "numeric",
              })}
            </p>
            {post.image_url && (
              <div className="img-frame mt-10 overflow-hidden">
                {isVideoUrl(post.image_url) ? (
                  <video src={post.image_url} controls playsInline preload="metadata" className="block h-auto w-full max-w-full object-contain" />
                ) : (
                  <img src={post.image_url} alt={post.title} className="block h-auto w-full max-w-full object-cover" />
                )}
              </div>
            )}
            <div
              data-testid="post-body"
              className="prose-neutral mt-10 space-y-5 text-base leading-relaxed text-ink/80 [&_a]:text-terra-500 [&_a]:underline [&_li]:ml-5 [&_li]:list-disc [&_strong]:font-semibold [&_strong]:text-ink"
              dangerouslySetInnerHTML={{ __html: post.body }}
            />
          </article>
        )}
      </section>
    </main>
  );
};

export default CampaignPost;
